import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { CalendarEventDto } from '@/types/calendar';

interface Props {
  event: CalendarEventDto;
}

const APPOINTMENT_STATUS_CONFIG: Record<string, { label: string; color: 'warning' | 'primary' | 'success' | 'default' }> = {
  pending:   { label: 'Очікує',       color: 'warning' },
  confirmed: { label: 'Підтверджено', color: 'primary' },
  completed: { label: 'Завершено',    color: 'success' },
};

const PARTICIPANT_ROLE_LABELS: Record<string, string> = {
  client: 'Клієнт',
  expert: 'Експерт',
};

export const AppointmentEventDetails: React.FC<Props> = ({ event }) => {
  const d = event.details;
  if (!d) return null;

  const rows: { label: string; value: string }[] = [];

  if (d.location) rows.push({ label: 'Місце', value: d.location });
  if (d.durationMinutes) rows.push({ label: 'Тривалість', value: `${d.durationMinutes} хв` });
  if (d.participantName) rows.push({ label: 'Учасник', value: d.participantName });
  if (d.notes) rows.push({ label: 'Нотатки', value: d.notes });

  const statusCfg = d.status ? APPOINTMENT_STATUS_CONFIG[d.status] : null;
  const roleLabel = d.participantRole ? PARTICIPANT_ROLE_LABELS[d.participantRole] : null;

  if (!rows.length && !statusCfg && !roleLabel) return null;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '4px 16px', alignItems: 'center' }}>
      {statusCfg && (
        <>
          <Typography variant="body2" color="text.secondary">Статус зустрічі</Typography>
          <Chip
            label={statusCfg.label}
            color={statusCfg.color}
            size="small"
            variant="outlined"
            sx={{ justifySelf: 'start' }}
          />
        </>
      )}
      {roleLabel && (
        <>
          <Typography variant="body2" color="text.secondary">Ваша роль</Typography>
          <Typography variant="body2">{roleLabel}</Typography>
        </>
      )}
      {rows.map(({ label, value }) => (
        <React.Fragment key={label}>
          <Typography variant="body2" color="text.secondary">{label}</Typography>
          <Typography variant="body2">{value}</Typography>
        </React.Fragment>
      ))}
    </Box>
  );
};
